<!-- <AppDate>2022-09-22T18:04:09.000000Z</AppDate> -->

<template>
  <div class="date">
    <!-- <app-svg id="calendar" /> -->
    <span v-date>
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "AppDate",
};
</script>

<style lang="scss" scoped>
.date {
  display: flex;
  align-items: center;
  height: 15px;
  font-size: 14px;
  line-height: 1;
  color: $color_dark-80;

  svg {
    width: 14px;
    height: 15px;
    margin-right: 9px;
  }
}
</style>
